import { join } from 'juriquery'

import { AUTH_EXCHANGE_ROUTE, AUTH_INACTIVITY_ROUTE } from './authentication'

export const AUDITS_ROOT_ROUTE = '/'
export const AUDITS_NO_ACCESS_ROUTE = '/no-access'
export const AUDITS_PERMISSION_REQUIRED_ROUTE = '/permission-required'
export const AUDITS_NOT_FOUND_ROUTE = '/404'
export const AUDITS_AUDITS_ROUTE = '/organizations/:organizationId/audits'
export const AUDITS_AUDIT_ROUTE =
  '/organizations/:organizationId/audits/:auditId'
export const AUDITS_CLINICS_ROUTE = '/organizations/:organizationId/clinics'

export const getAuditsRoute = () => AUDITS_ROOT_ROUTE

export const getAuditsExchangeUrl = (
  transactionId: string,
  code: string,
  appUrl: string,
) =>
  join(`${appUrl}${AUTH_EXCHANGE_ROUTE}`, {
    transaction_id: transactionId,
    code,
  })

export const getAuditsInactivityRoute = ({
  referrer,
  organization,
}: {
  referrer?: string
  organization?: string
}) => join(AUTH_INACTIVITY_ROUTE, { referrer, organization })

export const getAuditsNoAccessRoute = () => AUDITS_NO_ACCESS_ROUTE

export const getAuditsNotFoundRoute = () => AUDITS_NOT_FOUND_ROUTE

const getRouteWithInjectedVariables = (
  route: string,
  variables: Record<string, string | number>,
) =>
  Object.entries(variables).reduce(
    (acc, [key, value]) => acc.replace(`:${key}`, `${value}`),
    route,
  )

export const getAuditsAuditsRoute = (organizationId: number) =>
  getRouteWithInjectedVariables(AUDITS_AUDITS_ROUTE, { organizationId })

export const getAuditsAuditRoute = (organizationId: number, auditId: number) =>
  getRouteWithInjectedVariables(AUDITS_AUDIT_ROUTE, {
    organizationId,
    auditId,
  })

export const getAuditsClinicsRoute = (organizationId: number) =>
  getRouteWithInjectedVariables(AUDITS_CLINICS_ROUTE, { organizationId })
